import { ReactNode } from "react"
import { Grid, Stack } from "@mui/material"
import { MRT_FullScreenToggleButton, MRT_TableInstance } from "material-react-table"
import { StandardToggleGlobalFilterButton } from "./StandardToggleGlobalFilterButton"

interface BaseTableFilterProps {
    variant: "left" | "right"
    showGlobalFilterButton?: boolean
    showFullScreenToggleButton?: boolean
    children?: ReactNode
}
interface LeftTableFilterProps extends BaseTableFilterProps {
    variant: "left"
    stackClassName?: string
    table?: never
}

interface RightTableFilterProps<TData extends Record<string, any>> extends BaseTableFilterProps {
    variant: "right"
    stackClassName?: string
    table: MRT_TableInstance<TData>
}

type TableFilterProps<TData extends Record<string, any>> = LeftTableFilterProps | RightTableFilterProps<TData>

export function StandardTableFilter<TData extends Record<string, any>>({
    variant,
    table,
    children,
    stackClassName,
    showGlobalFilterButton = true,
    showFullScreenToggleButton = true,
}: TableFilterProps<TData>) {
    return (
        <Grid container flexWrap="nowrap" gap={2} padding="1rem">
            {variant === "left" && (
                <Stack direction="row" gap={2} className={stackClassName}>
                    {children}
                </Stack>
            )}

            {variant === "right" && (
                <Stack direction="row" paddingTop=".5rem" spacing={1} className={stackClassName}>
                    {children}
                    {showGlobalFilterButton && <StandardToggleGlobalFilterButton table={table} />}
                    {showFullScreenToggleButton && <MRT_FullScreenToggleButton table={table} />}
                </Stack>
            )}
        </Grid>
    )
}
